import {
  isAudio,
  isImage,
  isVideo,
} from 'shared_DEPRECATED/components/File/utils';

export const isMediaFile = (contentType: string) =>
  isImage(contentType) || isVideo(contentType) || isAudio(contentType);
